<template>
  <v-card >
        <div style="margin:auto; padding:1.5rem; height: 80vh; overflow:auto;">
    <v-row :justify="'center'">
      <p class="display-3">OpenSource License</p>
    </v-row>
    <b-button class="button-margin" v-b-toggle.collapse-open1 variant="outline-dark" block>Animate.css</b-button>
    <b-collapse id="collapse-open1" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/daneden/animate.css" style="color: blue;">
          https://github.com/animate-css/animate.css
        </b-link>
        <p class="card-text">
          The MIT License (MIT)
          <br>
          Copyright (c) 2019 Daniel Eden
          <br>
          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to deal
          in the Software without restriction, including without limitation the rights
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:
          <br>
          The above copyright notice and this permission notice shall be included in all
          copies or substantial portions of the Software.
          <br>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          SOFTWARE.
        </p>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open2 variant="outline-dark" block>SortableJS/Vue.Draggable
    </b-button>
    <b-collapse id="collapse-open2" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/SortableJS/Vue.Draggable" style="color: blue;">
          https://github.com/SortableJS/Vue.Draggable
        </b-link>
        <pre class="card-text">
          The MIT License (MIT)
          <br>
          Copyright (c) 2016-2019 David Desmaisons
          <br>
          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to deal
          in the Software without restriction, including without limitation the rights
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:
          <br>
          The above copyright notice and this permission notice shall be included in all
          copies or substantial portions of the Software.
          <br>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open3 variant="outline-dark" block>CroudTech/vue-fullcalendar
    </b-button>
    <b-collapse id="collapse-open3" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/CroudTech/vue-fullcalendar" style="color: blue;">
          https://github.com/CroudTech/vue-fullcalendar
        </b-link>
        <pre class="card-text">
          MIT License
          <br>
          Copyright (c) 2017 Croud Support
          <br>
          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to deal
          in the Software without restriction, including without limitation the rights
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:
          <br>
          The above copyright notice and this permission notice shall be included in all
          copies or substantial portions of the Software.
          <br>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open4 variant="outline-dark" block>mengxiong10/vue2-datepicker
    </b-button>
    <b-collapse id="collapse-open4" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/mengxiong10/vue2-datepicker" style="color: blue;">
          https://github.com/mengxiong10/vue2-datepicker
        </b-link>
        <pre class="card-text">
          MIT License
          <br>
          Copyright (c) 2018 xiemengxiong
          <br>
          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to deal
          in the Software without restriction, including without limitation the rights
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:
          <br>
          The above copyright notice and this permission notice shall be included in all
          copies or substantial portions of the Software.
          <br>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open5 variant="outline-dark" block>saintplay/vue-swatches
    </b-button>
    <b-collapse id="collapse-open5" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/saintplay/vue-swatches" style="color: blue;">
          https://github.com/saintplay/vue-swatches
        </b-link>
        <pre class="card-text">
          MIT License
          <br>
          Copyright (c) 2018 - Present Diego Jara
          <br>
          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to deal
          in the Software without restriction, including without limitation the rights
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:
          <br>
          The above copyright notice and this permission notice shall be included in all
          copies or substantial portions of the Software.
          <br>
          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
          SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open6 variant="outline-dark" block>vuetify
    </b-button>
    <b-collapse id="collapse-open6" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md" style="color: blue;">
          https://github.com/vuetifyjs/vuetify/blob/master/LICENSE.md
        </b-link>
        <pre>The MIT License (MIT)

          Copyright (c) 2016-2020 John Jeremy Leider

          Permission is hereby granted, free of charge, to any person obtaining a copy 
          of this software and associated documentation files (the "Software"), to deal 
          in the Software without restriction, including without limitation the rights 
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
          copies of the Software, and to permit persons to whom the Software is furnished 
          to do so, subject to the following conditions:

          The above copyright notice and this permission notice shall be included in 
          all copies or substantial portions of the Software.

          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL 
          THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING 
          FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS 
          IN THE SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open7 variant="outline-dark" block>themekit
    </b-button>
    <b-collapse id="collapse-open7" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/Shopify/themekit" style="color: blue;">
          https://github.com/Shopify/themekit/blob/master/LICENSE
        </b-link>
        <pre>The MIT License (MIT)

          Copyright (c) 2014 Shopify

          Permission is hereby granted, free of charge, to any person obtaining a copy
          of this software and associated documentation files (the "Software"), to deal
          in the Software without restriction, including without limitation the rights
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
          copies of the Software, and to permit persons to whom the Software is
          furnished to do so, subject to the following conditions:

          The above copyright notice and this permission notice shall be included in
          all copies or substantial portions of the Software.

          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
          THE SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>
    <b-button class="button-margin" v-b-toggle.collapse-open8 variant="outline-dark" block>RTCMultiConnection
    </b-button>
    <b-collapse id="collapse-open8" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://github.com/muaz-khan/RTCMultiConnection/blob/master/LICENSE.md" style="color: blue;">
          https://github.com/muaz-khan/RTCMultiConnection/blob/master/LICENSE.md
        </b-link>
        <pre>The MIT License
          Copyright (c) 2014-2018 Muaz Khan 

          Permission is hereby granted, free of charge, to any person obtaining a copy 
          of this software and associated documentation files (the "Software"), to deal 
          in the Software without restriction, including without limitation the rights 
          to use, copy, modify, merge, publish, distribute, sublicense, and/or sell 
          copies of the Software, and to permit persons to whom the Software is furnished 
          to do so, subject to the following conditions:

          The above copyright notice and this permission notice shall be included in 
          all copies or substantial portions of the Software.

          THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR 
          IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY, 
          FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE 
          AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER 
          LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, 
          OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN 
          THE SOFTWARE.
        </pre>
      </b-card>
    </b-collapse>

    <b-button class="button-margin" v-b-toggle.collapse-open9 variant="outline-dark" block>WebRTC
    </b-button>
    <b-collapse id="collapse-open9" class="mt-2">
      <b-card>
        <span>link :</span>
        <b-link href="https://webrtc.org/support/license?hl=ko" style="color: blue;">
          https://webrtc.org/support/license?hl=ko
        </b-link>
        <pre>Software License
          Copyright (c) 2011, The WebRTC project authors. All rights reserved.

          Redistribution and use in source and binary forms, with or without modification, 
          are permitted provided that the following conditions are met:

          Redistributions of source code must retain the above copyright notice, this list 
          of conditions and the following disclaimer.

          Redistributions in binary form must reproduce the above copyright notice, this 
          list of conditions and the following disclaimer in the documentation and/or other 
          materials provided with the distribution.

          Neither the name of Google nor the names of its contributors may be used to 
          endorse or promote products derived from this software without specific prior 
          written permission.

          THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" 
          AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED 
          WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. 
          IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, 
          INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT 
          NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
          PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, 
          WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) 
          ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY 
          OF SUCH DAMAGE.
        </pre>
      </b-card>
    </b-collapse>
    </div>
  </v-card>
</template>
<script>
export default {
  name: 'CopyRight',
  data() {
    return {}
  },
  props: {
    dialog: false
  }
}
</script>
<style scope>
.button-margin {
  margin-bottom: 10px;
  
}
pre{
  white-space: pre-wrap;       /* Since CSS 2.1 */
  white-space: -moz-pre-wrap;  /* Mozilla, since 1999 */
  white-space: -pre-wrap;      /* Opera 4-6 */
  white-space: -o-pre-wrap;    /* Opera 7 */
  word-wrap: break-word;
}
</style>
